module.exports = __webpack_public_path__ + "assets/523fd7642aab5a155d9b7eac81203914.png";